import Box from '@mui/material/Box';
import Link from '@mui/material/Link';

import { RouterLink } from 'src/routes/components';
import { paths, newSearchParams } from 'src/routes/paths';

import { Iconify } from 'src/components/iconify';
import { ButtonFollow } from 'src/components/custom-buttons';

// ----------------------------------------------------------------------

export function AccountTitle({ user, slotProps, hideButton, sx, ...other }) {
  return (
    <Box
      sx={[
        {
          gap: 1,
          width: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      {...other}
    >
      <Box
        sx={{ gap: 0.5, display: 'grid', alignItems: 'center', gridTemplateColumns: '1fr auto' }}
      >
        <Link
          noWrap
          color="inherit"
          component={RouterLink}
          href={`${paths.user.profile(user?.id)}${newSearchParams({ country: user?.country })}`}
          sx={[
            { display: 'inline-block' },
            ...(Array.isArray(slotProps?.title?.sx)
              ? (slotProps?.title?.sx ?? [])
              : [slotProps?.title?.sx]),
          ]}
        >
          {user?.companyName}
        </Link>

        {user?.verifiedAccount && (
          <Iconify
            width={16}
            icon="solar:verified-check-bold"
            sx={[
              { color: 'info.main' },
              ...(Array.isArray(slotProps?.iconify?.sx)
                ? (slotProps?.iconify?.sx ?? [])
                : [slotProps?.iconify?.sx]),
            ]}
          />
        )}
      </Box>

      {user?.id && !hideButton && (
        <ButtonFollow
          userId={user?.id}
          sx={[
            ...(Array.isArray(slotProps?.button?.sx)
              ? (slotProps?.button?.sx ?? [])
              : [slotProps?.button?.sx]),
          ]}
        />
      )}
    </Box>
  );
}
